export default __webpack_public_path__ + "static/media/mcv-logo-long.a831f6f7.svg";